/**
 * @flow
 * @relayHash c5d9e887b91b58885239cbe6873d623a
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type ResponseDetailsRenderer_ResponseDetails_QueryResponse = {|
  +response: ?{|
    +savedSchema: any;
    +savedUiSchema: any;
    +response: any;
    +simpleDisplay: ?$ReadOnlyArray<?$ReadOnlyArray<?string>>;
  |};
|};
*/


/*
query ResponseDetailsRenderer_ResponseDetails_Query(
  $responseId: ID!
) {
  response(id: $responseId) {
    savedSchema
    savedUiSchema
    response
    simpleDisplay
    id
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "responseId",
        "type": "ID!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ResponseDetailsRenderer_ResponseDetails_Query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "responseId",
            "type": "ID!"
          }
        ],
        "concreteType": "FormResponse",
        "name": "response",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "savedSchema",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "savedUiSchema",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "response",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "simpleDisplay",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "ResponseDetailsRenderer_ResponseDetails_Query",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "responseId",
        "type": "ID!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "ResponseDetailsRenderer_ResponseDetails_Query",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "responseId",
            "type": "ID!"
          }
        ],
        "concreteType": "FormResponse",
        "name": "response",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "savedSchema",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "savedUiSchema",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "response",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "simpleDisplay",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query ResponseDetailsRenderer_ResponseDetails_Query(\n  $responseId: ID!\n) {\n  response(id: $responseId) {\n    savedSchema\n    savedUiSchema\n    response\n    simpleDisplay\n    id\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// /src/components/Forms/__generated__/ResponseDetailsRenderer_ResponseDetails_Query.graphql.js